import classNames from "classnames"
import React from "react"

import s from "./Form.module.scss"

export default function Submit({ className, disabled, value }) {
  return (
    <div
      className={classNames(s.formField, className, { [s.disabled]: disabled })}
    >
      <input type="submit" value={value} />
    </div>
  )
}
